import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'
import { supabase } from './supabase'
import profileImage from './img/Rectangle 6.png'
import phoneIcon from './img/phone-icon.png'
import emailIcon from './img/email-icon.png'
import agencyIcon from './img/agency.png'
import brandingIcon from './img/branding.png'
import digitalIcon from './img/digital.png'
import editorialIcon from './img/editorial.png'
import mediaIcon from './img/media.png'
import photoIcon from './img/photo.png'
import printIcon from './img/print.png'
import promoIcon from './img/promo.png'
import videoIcon from './img/video.png'
import webIcon from './img/web.png'
import marketingIcon from './img/365DTN_logo white.png'
import facebookIcon from './img/Facebook.png'
import instagramIcon from './img/Instagram.png'
import youtubeIcon from './img/YouTube.png'
import vCard from './img/savevcard2.png'
import prIcon from './img/Commercial.png'

const EmployeePage = () => {
  const { slug } = useParams()
  const [employee, setEmployee] = useState(null)

  useEffect(() => {
    const fetchEmployee = async () => {
      const { data, error } = await supabase
        .from('365_employees')
        .select('*')
        .eq('slug', slug)
        .single()

      if (error) {
        console.error('Not Found', error.message)
      } else {
        setEmployee(data)
      }
    }

    fetchEmployee()
  }, [slug])

  if (!employee) return <div>Loading...</div>

  const formattedPosition = employee.position.replace(/of/g, 'of<br />')

  const highlightAtSymbol = (text) => {
    return text.split('@').map((part, index) =>
      index === 0 ? (
        part
      ) : (
        <>
          <span className="at-symbol">@</span>
          {part}
        </>
      )
    )
  }

  return (
    <div className="business-card">
      <Helmet>
        <title>{employee.name}</title>
        <meta
          name="description"
          content={`Details about ${employee.name}, who works as a ${employee.position}.`}
        />
      </Helmet>
      <header></header>
      <a href="https://365degreetotalmarketing.com/">
        <img src={profileImage} alt="Profile" className="logo" />
      </a>
      <div className="profile-info">
        <img src={employee.img} alt={employee.name} className="photo-profile" />
        <div>
          <h1>{employee.name}</h1>
          <p
            className="description"
            dangerouslySetInnerHTML={{ __html: formattedPosition }}
          />
          <div className="contact-icons">
            <a href={`tel:${employee.phone}`} className="contact-icon">
              <img src={phoneIcon} alt="Phone" className="contact-icon-img" />
              <p>Phone</p>
            </a>
            <a href={`mailto:${employee.mail}`} className="contact-icon">
              <img src={emailIcon} alt="Email" className="contact-icon-img" />
              <p>Email</p>
            </a>
          </div>
        </div>
      </div>
      <div className="contact-info">
        <a href={`tel:${employee.phone}`} className="contact-text">
          <p className="contact-title">Phone</p>
          <p>{employee.phone}</p>
        </a>
        <a href={`mailto:${employee.mail}`} className="contact-text">
          <p className="contact-title">Email</p>
          {highlightAtSymbol(employee.mail)}
        </a>
      </div>
      <div className="services-icons">
        <a
          href="https://365degreetotalmarketing.com/"
          target="_blank"
          className="service-icon"
        >
          <img src={agencyIcon} alt="Phone" className="services-icon-img" />
          <p>Agency</p>
        </a>
        <a
          href="https://365degreetotalmarketing.com/branding.php"
          target="_blank"
          className="service-icon"
        >
          <img src={brandingIcon} alt="Email" className="services-icon-img" />
          <p>Branding</p>
        </a>
        <a
          href="https://365degreetotalmarketing.com/digital-marketing-social-media.php"
          target="_blank"
          className="service-icon"
        >
          <img src={digitalIcon} alt="Phone" className="services-icon-img" />
          <p>Digital</p>
        </a>
        <a
          href="https://365degreetotalmarketing.com/print-marketing-magazines.php"
          target="_blank"
          className="service-icon"
        >
          <img src={editorialIcon} alt="Email" className="services-icon-img" />
          <p>Editorial</p>
        </a>
        <a
          href="https://365degreetotalmarketing.com/"
          target="_blank"
          className="service-icon"
        >
          <img src={mediaIcon} alt="Phone" className="services-icon-img" />
          <p>Media Buy</p>
        </a>
        <a
          href="https://365degreetotalmarketing.com/photography.php"
          target="_blank"
          className="service-icon"
        >
          <img src={photoIcon} alt="Email" className="services-icon-img" />
          <p>Photo</p>
        </a>
        <a
          href="https://365degreetotalmarketing.com/branding.php"
          target="_blank"
          className="service-icon"
        >
          <img src={printIcon} alt="Phone" className="services-icon-img" />
          <p>Print</p>
        </a>
        <a
          href="https://365degreetotalmarketing.com/"
          className="service-icon"
          download={`${employee.vcard}`}
        >
          <img src={prIcon} alt="" className="services-icon-img" />
          <p>PR</p>
        </a>
      </div>
      <div className="last-row">
        <a
          href="https://365degreetotalmarketing.com/"
          target="_blank"
          className="service-icon"
        >
          <img src={promoIcon} alt="Email" className="services-icon-img" />
          <p>Promo</p>
        </a>
        <a
          href="https://365degreetotalmarketing.com/video.php"
          target="_blank"
          className="service-icon"
        >
          <img src={videoIcon} alt="Phone" className="services-icon-img" />
          <p>Video</p>
        </a>
        <a
          href="https://365degreetotalmarketing.com/digital-marketing-websites-mobile.php"
          target="_blank"
          className="service-icon"
        >
          <img src={webIcon} alt="Email" className="services-icon-img" />
          <p>Web</p>
        </a>

        <a
          href={`${employee.vcard}`}
          className="service-icon"
          download={`${employee.vcard}`}
        >
          <img src={vCard} alt="" className="services-icon-img" />
          <p>Vcard</p>
        </a>
      </div>

      <footer>
        <a href="http://www.365degreetotalmarketing.com" className="copyright">
          365degreetotalmarketing.com
        </a>
        <div className="footer-icon">
          <a
            href="http://www.365degreetotalmarketing.com"
            className="service-icon"
            target="_blank"
          >
            <img src={marketingIcon} alt="" className="footer-icon-img" />
          </a>
          <a
            href="https://www.facebook.com/365dtm/"
            className="service-icon"
            target="_blank"
          >
            <img src={facebookIcon} alt="" className="footer-icon-img" />
          </a>
          <a
            href="https://www.instagram.com/365dtm/"
            className="service-icon"
            target="_blank"
          >
            <img src={instagramIcon} alt="" className="footer-icon-img" />
          </a>
          <a
            href="https://www.youtube.com/c/365degreetotalmarketing"
            className="service-icon"
            target="_blank"
          >
            <img src={youtubeIcon} alt="Email" className="footer-icon-img" />
          </a>
        </div>
      </footer>
    </div>
  )
}

export default EmployeePage
